import i18next from "i18next";
import { initReactI18next } from "react-i18next";

export async function createUnsubI18n({ lng = "en", resources = {} } = {}) {
  const i18n = i18next.createInstance();

  await i18n
    .use(initReactI18next)
    .init({
        supportedLngs: [
            'DE_AT',
            'DE_CH',
            'DE_DE',
            'EN_AF',
            'EN_AU',
            'EN_CA',
            'EN_GB',
            'EN_IE',
            'EN_ROW',
            'EN_US',
            'ES_HO',
            'ES_MX',
            'ES_ROW',
            'ES_US',
            'ES_AR',
            'FR_CA',
            'FR_FR',
            'HR_HR',
            'HU_HU',
            'IT_IT',
            'NL_NL',
            'NL_BE',
            'PL_PL',
            'PT_BR',
            'PT_PT',
            'SK_SK',
            'TL_PH',
            'VLS_BE',
        ],
      resources,
      lng,
      fallbackLng: "EN_ROW",
      interpolation: { escapeValue: false },
      react: { useSuspense: false },
    });

  return i18n;
}
